// Use shared base API for endpoint injection
import { api } from '../middleware/api';

export const stmgroupApi = api
  .enhanceEndpoints({ addTagTypes: ['STMGroup'] })
  .injectEndpoints({
    endpoints: builder => ({
      getSTMGroups: builder.query<po_mgroup[], string>({
        query: cid => `stmgroup/${cid}`,
        providesTags: ['STMGroup']
      }),
      getSTMGroupById: builder.query<po_mgroup, string>({
        query: id => `stmgroup/byid/${id}`,
        providesTags: ['STMGroup']
      }),
      importSTMGroup: builder.mutation<{}, FormData>({
        query: (importData: FormData) => ({
          url: `stmgroup/import`,
          method: 'POST',
          body: importData
        }),
        invalidatesTags: ['STMGroup']
      }),
      insertSTMGroup: builder.mutation({
        query: stmgroup => ({
          url: `stmgroup/`,
          method: 'POST',
          body: stmgroup
        }),
        invalidatesTags: ['STMGroup']
      }),
      updateSTMGroup: builder.mutation({
        query: stmgroup => ({
          url: `stmgroup/`,
          method: 'PUT',
          body: stmgroup
        }),
        invalidatesTags: ['STMGroup']
      }),
      deleteSTMGroup: builder.mutation({
        query: stmgroup => ({
          url: `stmgroup/${stmgroup.gr_id}`,
          method: 'DELETE'
        }),
        invalidatesTags: ['STMGroup']
      })
    }),
    overrideExisting: false
  });

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useGetSTMGroupsQuery,
  useGetSTMGroupByIdQuery,
  useImportSTMGroupMutation,
  useInsertSTMGroupMutation,
  useUpdateSTMGroupMutation,
  useDeleteSTMGroupMutation
} = stmgroupApi;

